import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const rentalActiveWidget: DashboardWidgetConfiguration = {
  widgetId: "rental.active",
  name: "Active rentals",
  description: "Active rentals for the selected dashboard period.",
  apps: [
    "rental",
  ],
  template: "number",
  query: {
    kind: "single",
    query: {
      version: 1,
      source: "rental.orders",
      ...period(30),
      select: [
        {
          type: "aggregate",
          function: "count_distinct",
          field: "order_id",
          as: "value",
        },
      ],
      where: {
        type: "condition",
        field: "status",
        operator: "in",
        value: [
          "picked_up",
          "return_pending",
        ],
      },
    },
  },
  inputs: {
    label: "Active rentals",
    subtext: "in the last 30 days",
    icon: "briefcase",
    color: "azure",
    valueFormat: "number",
    valueMultiplier: 1,
  },
  dummyData: {
    value: 0,
    subtext: "Last 30 days",
  },
  limits: {
    minWidth: 2,
    maxWidth: 6,
    minHeight: 1,
    maxHeight: 2,
    defaultWidth: 4,
    defaultHeight: 1,
  },
};
